module.exports = __webpack_public_path__ + "img/construction_work.15101e42.jpg";